import {useState} from "react";
import {DropdownInputPropsType} from "../../../types/form-types";
import DropdownInput from "../../../components/common/form/inputs/dropdown/DropdownInput";
import {IdNameType} from "../../../types/common-types";
import useAppContext from "../../../utilities/hooks/useAppContext";

enum DefaultViews {
    Dashboard = 'dashboard',
    Accommodation = "accommodation",
    Agriculture = 'agriculture'
}

type DefaultViewModel = IdNameType<DefaultViews, string>

const DEFAULT_VIEW_KEY = 'app-defaultview';

export function getDefaultView(): DefaultViews {
    return (localStorage.getItem(DEFAULT_VIEW_KEY) as DefaultViews) || DefaultViews.Dashboard;
}

const UISettings = () => {
    const context = useAppContext();
    const data = [
        {
            id: DefaultViews.Dashboard,
            name: context.t(`pages.dashboard`)
        },
        {
            id: DefaultViews.Accommodation,
            name: context.t(`pages.accommodation.main`)
        },
        {
            id: DefaultViews.Agriculture,
            name: context.t(`pages.agriculture.main`)
        }
    ];
    const [defaultView, setDefaultView] = useState<DefaultViewModel>(data.find(x => x.id === getDefaultView())!);

    const onChange = (value: DefaultViewModel) => {
        localStorage.setItem(DEFAULT_VIEW_KEY, value.id);
        setDefaultView(value);
        window.location.reload();
    }

    const dropdownConfig: DropdownInputPropsType<DefaultViewModel> = {
        dataSource: {
            data: data
        },
        getItemId: i => i.id,
        label: 'settings.ui.selectHomePage',
        name: 'selectHomePage',
        required: true,
        view: {
            inputView: i => i?.name || ''
        },
        onChange: v => onChange(v!)
    };

    return (
        <div>
            <h1>Ui settings</h1>
            <hr/>
            <div>
                <DropdownInput {...dropdownConfig} value={defaultView}/>
            </div>
        </div>
    );
}

export default UISettings;
